namespace RecordShield.Wallet {
    export interface CreditConfigRow {
        Id?: number;
        FromGb?: number;
        UptoGb?: number;
        Credits?: number;
        ValidFrom?: string;
        ValidThru?: string;
        IsActive?: boolean;
    }

    export namespace CreditConfigRow {
        export const idProperty = 'Id';
        export const localTextPrefix = 'Wallet.CreditConfig';

        export namespace Fields {
            export declare const Id: string;
            export declare const FromGb: string;
            export declare const UptoGb: string;
            export declare const Credits: string;
            export declare const ValidFrom: string;
            export declare const ValidThru: string;
            export declare const IsActive: string;
        }

        ['Id', 'FromGb', 'UptoGb', 'Credits', 'ValidFrom', 'ValidThru', 'IsActive'].forEach(x => (<any>Fields)[x] = x);
    }
}
